import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import EventoTopo from '../section-pages/evento-topo'; 
import EventoInscricaoDetalhes from '../section-pages/evento-inscricao-detalhes';
import EventoInscricaoNaoFiliado from '../section-pages/evento-inscricao-nao-filiado';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import ApiEvento from '../services/eventoService';

export default function EventoInscricao() {
  const { slug } = useParams();
  const [evento, setEvento] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const user = JSON.parse(localStorage.getItem('user'));

  const fetchEvento = async () => {
    try {
      const response = await ApiEvento.obterPorUrl(slug);
      setEvento(response.data.evento[0]);
    } catch (error) {
      console.error('Erro ao buscar evento:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEvento();
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader) {
        setTimeout(() => {
          loader.classList.add('fadeOut');
          loader.style.display = 'none';
        }, 600);
      }
    }
  }, []);

  // Verifica se a inscrição está dentro do período
  const inscricaoAberta = (() => {
    if (!evento?.inicioInscricao || !evento?.fimInscricao) return false;

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const inicio = new Date(evento.inicioInscricao);
    inicio.setHours(0, 0, 0, 0);

    const fim = new Date(evento.fimInscricao);
    fim.setHours(23, 59, 59, 999);

    return hoje >= inicio && hoje <= fim;
  })();

  return (
    <>
      {/* HEAD */}
      <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>Fetron - Federação de Taekwondô de Rondônia</title>
      </Helmet>

      {/* LOADER */}
      <div id="mainpreloader">
        <Preloader />
      </div>

      {/* MENU */}
      <div className="home dark-scheme">
        <header id="header-wrap">
          <Navbar />
        </header>

        <section>
          {evento ? (
            <EventoTopo
              evento={evento}
            />
          ) : (
            <p>Carregando evento...</p>
          )}
        </section>

        {/* section */}
        <section className="no-top">
          {inscricaoAberta ? (
            user ? (
              <EventoInscricaoDetalhes evento={evento} />
            ) : (
              <EventoInscricaoNaoFiliado evento={evento} />
            )
          ) : (
            evento && (
              <div style={{ textAlign: 'center', padding: '2rem', color: 'white' }}>
                <h3>Inscrições indisponíveis</h3>
                <h4 className='mt-5'>
                  Período de inscrição: <strong>{new Date(evento.inicioInscricao).toLocaleDateString()}</strong> a{' '}
                  <strong>{new Date(evento.fimInscricao).toLocaleDateString()}</strong>
                </h4>
              </div>
            )
          )}
        </section>

        {/* Footer */}
        <Footer />
      </div>

      <ScrollToTopBtn />
    </>
  );
}
